import { theme_accessibility } from './_modules/accessibility';
import { theme_LoadMorePosts } from './_modules/infiniteScroll';
import { theme_initPasswordForm, theme_passwordFormSubmit } from './_modules/formSubmit';
import { theme_cookieConsentHandler } from './_modules/cookieConsent';
import { theme_photoswipe } from './_modules/photoSwipe';

document.addEventListener('DOMContentLoaded', () => {

	theme_photoswipe();
	theme_accessibility();
	theme_LoadMorePosts();
	theme_initPasswordForm();
	theme_passwordFormSubmit();
	theme_cookieConsentHandler();

});
